<div class="relative flex max-w-32 flex-col items-center justify-center gap-1.5 text-center">
  <div
    class="relative h-32 w-32 rounded-lg"
    [style.backgroundColor]="productBackgroundColor() | contentBuilderColor"
  >
    <img
      *ngIf="thumbnail()"
      class="push-image h-full w-full rounded-lg bg-center object-cover"
      [src]="thumbnail()"
      alt="image"
    />
    <div
      *ngIf="!isAvailable() || hasProductToReplace()"
      class="absolute inset-0 z-10 rounded-lg bg-black bg-opacity-50"
    ></div>
    <div
      *ngIf="!isAvailable() || hasProductToReplace()"
      class="absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2 transform rounded-lg bg-red-100 px-2 py-1 text-center text-xs font-medium text-red-600"
    >
      {{
        hasProductToReplace()
          ? ('kiosk-product-overview-cart-atom.product-to-replace' | translate)
          : ('kiosk-product-overview-cart-atom.not-available' | translate)
      }}
    </div>
    <span
      class="absolute -top-2 right-3 flex h-6 w-6 items-center justify-center rounded-full text-center text-sm font-bold"
      [style.backgroundColor]="dotColor() | contentBuilderColor"
      [style.color]="dotTextColor() | contentBuilderColor"
      >x{{ quantity() }}</span
    >
  </div>
  <p
    class="whitespace-nowrap break-words text-left text-base font-semibold"
    [style.color]="productTextColor() | contentBuilderColor"
  >
    {{ truncatedName() }}
  </p>
</div>
